import CompanyInvoiceDetailsTableView from './companyInvoiceDetailsTableView';

export default CompanyInvoiceDetailsTableView;
